// extracted by mini-css-extract-plugin
module.exports = {"emptyContent":"EmptyContent_emptyContent__rvSuA","displayText":"EmptyContent_displayText__2Lx3r"};